/**
 * Redux Slice para gerenciamento do estado de busca
 */

import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SearchState, BusinessInfo, SearchParams } from '../../types';

const initialState: SearchState = {
  isSearching: false,
  results: [],
  error: undefined,
  lastSearch: undefined
};

const searchSlice = createSlice({
  name: 'search',
  initialState,
  reducers: {
    startSearch: (state, action: PayloadAction<SearchParams>) => {
      state.isSearching = true;
      state.error = undefined;
      state.lastSearch = action.payload;
    },
    searchSuccess: (state, action: PayloadAction<BusinessInfo[]>) => {
      state.isSearching = false;
      state.results = action.payload;
      state.error = undefined;
    },
    searchError: (state, action: PayloadAction<string>) => {
      state.isSearching = false;
      state.error = action.payload;
    },
    clearResults: (state) => {
      state.results = [];
      state.error = undefined;
      state.lastSearch = undefined;
    },
    updateBusinessInfo: (state, action: PayloadAction<BusinessInfo>) => {
      const index = state.results.findIndex(b => b.id === action.payload.id);
      if (index !== -1) {
        state.results[index] = action.payload;
      }
    }
  }
});

export const {
  startSearch,
  searchSuccess,
  searchError,
  clearResults,
  updateBusinessInfo
} = searchSlice.actions;

export default searchSlice.reducer;





